import { checkIfReactNative } from '../base/util/checkOS';

/**
 * The supported remote video resolutions. The values are currently based on
 * available simulcast layers.
 *
 * @type {object}
 */
export const VIDEO_QUALITY_LEVELS = {
    AUTO: 1080,
    HIGH: 720,
    STANDARD: 480,
    MEDIUM: 360,
    LOW: 240
};

/**
 * Maps quality level names used in the config.videoQuality.minHeightForQualityLvl to the quality level constants used
 * by the application.
 *
 * @type {Object}
 */
export const CFG_LVL_TO_APP_QUALITY_LVL = {
    'low': VIDEO_QUALITY_LEVELS.LOW,
    'standard': VIDEO_QUALITY_LEVELS.STANDARD,
    'high': VIDEO_QUALITY_LEVELS.HIGH
};

/**
 * The quality to start at when the user has expressed no preference of their
 * own.
 *
 * Mobile starts at MEDIUM: it is usually on a cellular connection, on a screen
 * where the difference is hard to see, and paying for the bytes.
 *
 * Desktop starts at AUTO: it is usually on a fast connection, on a screen
 *
 * @type {number}
 */
export const DEFAULT_PREFERRED_VIDEO_QUALITY
    = checkIfReactNative() ? VIDEO_QUALITY_LEVELS.MEDIUM : VIDEO_QUALITY_LEVELS.AUTO;

/**
 * The maximum video quality to receive.
 *
 * @type {number}
 */
export const DEFAULT_MAX_RECEIVER_VIDEO_QUALITY
    = checkIfReactNative() ? VIDEO_QUALITY_LEVELS.MEDIUM : VIDEO_QUALITY_LEVELS.AUTO;
